(function documentContainerActionDefinition() {
    'use strict';
    angular.module('Actions')
        .service('documentContainerAction', [
            '$translate', 'documentContainerService', 'alerts', 'errorsExtend', '$q', 'authExtend', 'fileService', 'fileDownloader',
            function documentContainerAction($translate, documentContainerService, alerts, errors, $q, authExtend, fileService, fileDownloader) {
                this.checkIn = function checkIn(container) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    $translate(['Warning', 'DocumentContainerCheckInConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentContainerCheckInConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return result;
                            }

                            return documentContainerService.chekIn(container).then(function getOk(result) {
                                errors.showSuccess('DocumentContainerCheckInSucces');
                                defered.resolve(result);
                            }, function (error) {
                                errors.showError(error);
                                defered.reject(error);
                            });
                        });
                    });
                    return promise;
                };

                this.checkInAll = function checkInAll(container) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    var checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                    var accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');

                    if (!accesCheckIn && !checkInVersioned) {
                        errors.showError('Forbidden');
                        defered.reject('Forbidden');
                        return promise;
                    }

                    $translate(['Warning', 'DocumentContainerCheckInAllConfirmText', 'CheckInAllCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentContainerCheckInAllConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }

                            if (checkInVersioned && accesCheckIn) {
                                return alerts.confirm(translated.Warning, translated.CheckInAllCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {
                                    return documentContainerService.checkInAll(createVersion, container).then(function (doc) {
                                        errors.showSuccess('DocumentContainerCheckInSucces');
                                        defered.resolve(doc);
                                    }, function (error) {
                                        errors.showError(error);
                                        defered.reject(error);
                                    });
                                });
                            } else {
                                return documentContainerService.checkInAll(checkInVersioned, container).then(function getOks(doc) {
                                    errors.showSuccess('DocumentContainerCheckInSucces');
                                    defered.resolve(doc);
                                }, function (error) {
                                    errors.showError(error.data.modelState);
                                    defered.reject(error);
                                });
                            }
                        });
                    });

                    return promise;
                };

                this.deleteContainer = function deleteDoc(docu) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    $translate(['Warning', 'DocumentContainerDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentContainerDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }
                            return documentContainerService.delete(docu).then(function getOks(doc) {
                                errors.showSuccess('DocumentContainerDeleteSucces');
                                defered.resolve(doc);

                            }, function (error) {
                                errors.showError(error);
                                defered.reject();
                            });
                        });
                    });

                    return promise;
                }

                this.downloadFiles = function downloadFiles(container) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    var documents = container.documents;
                    fileService.masiveDownloadFilesDocument(documents).then(function (result) {

                        var today = new Date();
                        var success = fileDownloader.saveAs(result.value, container.id + '-' + container.name + '-' + today.getFullYear() + ("0" + (today.getMonth() + 1)).slice(-2) + ("0" + today.getDate()).slice(-2) + ("0" + today.getHours()).slice(-2) + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                        defered.resolve(result);
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }

                        defered.reject();
                    });

                    return promise;
                };

                this.downloadFilesContainer = function downloadFilesContainer(container) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    fileService.downloadFilesContainer(container.id).then(function (result) {
                        var today = new Date();
                        var fileName = container.id + '-' + container.name + '-' + today.getFullYear() + ("0" + (today.getMonth() + 1)).slice(-2) + ("0" + today.getDate()).slice(-2) + ("0" + today.getHours()).slice(-2) + '.zip';
                        var success = fileDownloader.saveAs(result.value, fileName);
                        if (!success) {
                            errors.showError('Api failed');
                        }

                        defered.resolve(result);
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError(error.data.modelState.error[0]);
                        }

                        defered.reject();
                    });

                    return promise;
                };
            }
        ]);
})();
